export default __webpack_public_path__ + "static/media/preparacion-nicho.15aaf668.svg";